export function PageSkeleton() {
  return (
    <div data-testid="page-skeleton" className="flex h-64 items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
    </div>
  );
}
